export const drawerConstants = {
  SHOW: 'DRAWER_SHOW',
  CLOSE: 'DRAWER_CLOSE',
}
